import { render, staticRenderFns } from "./tenantData.vue?vue&type=template&id=3dac47a7&"
import script from "./tenantData.vue?vue&type=script&lang=ts&"
export * from "./tenantData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tenantData.vue"
export default component.exports